import "./App.css";
import "./styles/style.scss";

import { Route, Routes } from "react-router-dom";
import React, { Suspense } from "react";

import DynamicWrapper from "./components/DynamicWrapper";
import Login from "./components/views/login";
import PrivateRoute from "./components/private-route";

// Lazy-loaded route components — reduces initial bundle parse time
const About = React.lazy(() => import("./components/views/about"));
const Home = React.lazy(() => import("./components/home"));
const ImageSelector = React.lazy(() => import("./components/image-selector"));
const Instructions = React.lazy(() => import("./graveyard/instructions"));
const New = React.lazy(() => import("./components/views/new"));
const Preview = React.lazy(() => import("./components/views/preview"));
const Produce = React.lazy(() => import("./components/views/produce"));
const Produce2 = React.lazy(() => import("./components/archive/produce2"));
const RoughParts = React.lazy(() => import("./components/parts"));
const Scene = React.lazy(() => import("./components/scene"));
const SettingsInspector = React.lazy(() => import("./components/views/settings"));
const Storyboards = React.lazy(() => import("./components/views/storyboards"));
const Takes = React.lazy(() => import("./components/views/takes"));
const Hunt = React.lazy(() => import("./components/views/hunt"));
const CR = React.lazy(() => import("./components/views/cr"));
const Strip = React.lazy(() => import('./components/views/Strip'));
const Account = React.lazy(() => import("./components/views/account"));
const Plan = React.lazy(() => import("./components/plan"));
const Credits = React.lazy(() => import("./components/views/credits"));
const PosesTool = React.lazy(() => import("./components/tools/poses"));
const ExpressionsTool = React.lazy(() => import("./components/tools/expressions"));
const FromScriptTool = React.lazy(() => import("./components/tools/from-script"));
const LocationsTool = React.lazy(() => import("./components/tools/locations"));
const PaletteTool = React.lazy(() => import("./components/tools/palette"));
const EditSoraTool = React.lazy(() => import("./components/tools/edit-sora"));
const NewSoraTool = React.lazy(() => import("./components/tools/sora"));
const ThreeActTool = React.lazy(() => import("./components/tools/three-act"));
const Attribution = React.lazy(() => import("./components/views/attribution"));
const SocialTool = React.lazy(() => import("./components/tools/social"));
const GrokStart = React.lazy(() => import("./components/tools/grok"));
const SeeDanceTool = React.lazy(() => import("./components/tools/seedance"));

const SuspenseFallback = (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1a1a2e' }}>
    <div style={{ width: 40, height: 40, border: '3px solid rgba(255,255,255,0.1)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <Suspense fallback={SuspenseFallback}>
    <Routes>
      {/* private */}
      <Route exact element={<PrivateRoute/>}>
        <Route path="/" exact element={<Storyboards />} />
        <Route path="/new" exact element={<New />} />
        <Route path="/idea" exact element={<RoughParts />} />
        <Route path="/account" exact element={<Account />} />
        {/*<Route path="/account/plan" exact element={<Plan />} />*/}
        <Route path="/account/credits" exact element={<Credits />} />
        {/*<Route path="/plan-bak" exact element={Scene} />*/}
        {/*<Route path="/demo1" exact element={SceneDemo1} />        // supported client facing demo preview */}
        {/*<Route path="/p/:id" exact element={Produce} />*/}
        <Route path="/image" exact element={<ImageSelector />} />
        <Route path="/p/:id/settings" exact element={<SettingsInspector />} />
        <Route path="/storyboards" exact element={<Storyboards />} />
        <Route path="/p/:id/attr" exact element={<Attribution />} />
        <Route path="/p/:id/strip" exact element={<Strip />} />
      </Route>
      // public
      <Route path="/ptl/image" exact element={<ImageSelector />} /> // when we click on takes from the portal with unauthed. Could force a sign in first.
      <Route path="/p/J-8cN_bPZHjm0u8R3ukSF" element={<Produce2 />} /> // custom link for one old event ... ok if its blank on other firebase projects
      <Route path="/p/:id/preview" exact element={<Preview />} />
      <Route path="/p/:id/:shotID" exact element={<Takes />} />
      <Route path="/p/:id/:shotID/hunt" exact element={<Hunt />} />
      <Route path="/p/:id/qr/:nth" exact element={<CR />} />

      <Route path="/p/:id" exact element={<Produce />} /> {/* primary public portal */}
      {/*<PrivateRoute path="/p/:id" exact children={<Produce />} />     // does not seem to auth private ..*/}
      {/* tools */}
      <Route path="/t/poses" exact element={<PosesTool />} />
      <Route path="/t/expressions" exact element={<ExpressionsTool />} />
      <Route path="/t/from-script" exact element={<FromScriptTool />} />
      <Route path="/t/ad" exact element={<NewSoraTool />} />
      <Route path="/t/locations" exact element={<LocationsTool />} />
      <Route path="/t/palette" exact element={<PaletteTool />} />
      <Route path="/t/edit-sora" exact element={<EditSoraTool />} />
      <Route path="/t/three-acts" exact element={<ThreeActTool />} />
      <Route path="/t/social" exact element={<SocialTool />} />
      <Route path="/t/microdrama" exact element={<SocialTool />} />
      // <Route path="/t/bear_850035" exact element={<SocialTool />} />
      <Route path="/t/grok" exact element={<GrokStart />} />
      <Route path="/t/seedance" exact element={<SeeDanceTool />} />



      {/* auth */}
      <Route path="/login" exact element={<Login />} />
      <Route path="/signup" exact element={<Login />} />
      <Route path="/forgotPassword" exact element={<Login />} />
      {/*<Route path="/example" exact element={<ExampleProduction />} />*/}
      {/* non-essential pages used for development and tests */}
      <Route path="/zela_bday_info" exact element={<Instructions />} />
      {/* historical bits */}
      {/*  // still functional at 2021, but moved to graveyard to not maintain react video recorder dependencies
            <Route path="/zela_bday" exact children={Home} />
            <Route path="/about" exact children={About} />
            <Route path="/recorder" exact children={Recorder}/>
            <PrivateRoute path="/recorder" exact children={Recorder}/>
            <Route path="/dnd_test" exact children={Layout} />
            <Route path="/static_scene" exact children={StaticScene} />
            */}
    </Routes>
    </Suspense>
  );
}

export default App;